import {ETariffDetailStatus, ETariffDetailType, ETariffStatus} from './definitions';

export default {
  addTariff: 'Добавить тариф',
  searchPlaceholder: 'Быстрый поиск по названию тарифа',
  th: {
    tariffId: 'ID тарифа',
    name: 'Название тарифа',
    documentType: 'Тип договора',
    channel: 'Канал',
    status: 'Статус',
    reseller: 'Реселлер',
  },
  filters: {
    countries: 'Страна',
    detailLabels: 'Название условия',
    detailTypes: 'Тип условия',
    pricingDetailLabels: 'Название тарификации',
    pricingDetailTypes: 'Тип тарификации',
    currencies: 'Валюта',
  },
  detailType: {
    [ETariffDetailType.LICENSE]: 'Лицензия',
    [ETariffDetailType.OPERATOR]: 'Оператор',
    [ETariffDetailType.REGION]: 'Направление',
  },
  tariffStatus: {
    [ETariffStatus.ACTIVE]: 'Активный',
    [ETariffStatus.ARCHIVED]: 'Архивный',
    [ETariffStatus.CLOSED]: 'Закрытый',
  },
  detailStatus: {
    [ETariffDetailStatus.ACTIVE]: 'Активно',
    [ETariffDetailStatus.PLANNED]: 'Запланировано',
  },
  detailStatusHint:
    'Секция "Запланировано" содержит условия или тарификации, для которых нет активных версий',
  tariffCard: {
    id: 'ID',
    reseller: 'Реселлер',
    documentType: 'Тип договора',
    label: 'Название',
    tariff: 'Тариф',
    tariffDetails: 'Условия тарифа',
    version: 'Версия',
    detailType: 'Тип условия',
    detailPricingType: 'Тип тарификации',
    activeFrom: 'Активно с',
    activeTo: 'Активно по',
    country: 'Страна',
    currency: 'Валюта',
    jsonData: 'Свойства в JSON',
    addTariffDetail: 'Добавить условие',
    uploadTariffFile: 'Загрузить файл с тарифом',
    tariffPricingDetails: 'Тарификация',
    addTariffPricingDetail: 'Добавить тарификацию',
    search: 'Фильтры',
    plannedChanges: 'Запланировано изменение',
    vatHint: 'Все цены указаны без учета НДС',
    changeTariff: 'Изменить условия',
    cancelPlannedChanges: 'Отменить изменения',
    cancelPlannedChangesSuccess: 'Все изменения успешно отменены',
    cancelPlannedChangesConfirm:
      'Вы уверены, что хотите удалить все запланированные изменения в тарифе без возможности восстановления?',
    smsCommon: 'Запрет управления операторами в Анкете',
  },
  actions: {
    showChanges: 'Посмотреть изменения',
    cancelChanges: 'Отменить изменения',
    edit: 'Редактировать',
    history: 'Посмотреть историю',
  },
  addTariffModal: {
    title: 'Создание тарифа',
    titleEdit: 'Изменение тарифа',
    name: 'Название тарифа',
    channel: 'Канал',
    reseller: 'Реселлер',
    documentType: 'Тип договора',
    saveContinue: 'Сохранить и продолжить',
    smsCommon: 'Запретить управление операторами в Анкете',
  },
  editTariffDetailForm: {
    title: 'Добавление условия тарифа',
    titleEdit: 'Изменение условия тарифа',
    label: 'Название условия тарифа',
    country: 'Страна',
    currency: 'Валюта',
    previousActiveFrom: 'Предыдущие дата и время активации',
    activeFrom: 'Дата и время активации',
    activeFromHint:
      'Ваш текущий часовой пояс не совпадает с часовым поясом Москвы. Выберите время и дату активации тарифа по Москве. \nИнформация о тарифе будет отображаться в вашем часовом поясе',
    data: 'Свойства условия',
    dataHint: 'Заполните свойства условия в формате JSON',
    comment: 'Комментарий по изменению',
    commentHint: 'К примеру, номер обращения в саппорт, по которому делаются эти изменения',
  },
  editTariffPricingDetailForm: {
    title: 'Добавление тарификации',
    titleEdit: 'Изменение тарификации',
    label: 'Название тарификации',
    previousActiveFrom: 'Предыдущие дата и время активации',
    activeFrom: 'Дата и время активации',
    activeFromHint:
      'Ваш текущий часовой пояс не совпадает с часовым поясом Москвы. Выберите время и дату активации тарифа по Москве. \nИнформация о тарифе будет отображаться в вашем часовом поясе',
    data: 'Свойства тарификации',
    dataHint: 'Заполните свойства тарификации в формате JSON',
    vatHint: 'Все цены должны быть указаны без учета НДС',
    comment: 'Комментарий по изменению',
    commentHint: 'К примеру, номер обращения в саппорт, по которому делаются эти изменения',
  },
  cancelChangesModal: {
    title: 'Отменить запланированные изменения?',
    subtitle: 'Изменения, запланированные ранее, не вступят в силу в указанный срок',
    submitButton: 'Отменить изменения',
    successNotification: 'Запланированные изменения успешно отменены',
  },
  plannedDetailModalTitle: 'Запланированные изменения',
  archivedDetailsModal: {
    detailsTitle: 'Архивные условия',
    pricingDetailsTitle: 'Архивные тарификации',
  },
  copyTariffModal: {
    title: 'Копирование тарифа',
    name: 'Копируемый тариф:',
    channel: 'Канал:',
    newName: 'Название нового тарифа',
    reseller: 'Реселлер',
    documentType: 'Тип договора',
    activeFrom: 'Дата и время активации тарифа',
    activeFromHint:
      'Ваш текущий часовой пояс не совпадает с часовым поясом Москвы. Выберите время и дату активации тарифа по Москве. \nИнформация о тарифе будет отображаться в вашем часовом поясе',
  },
  noData: 'Нет данных',
};
